import api from 'ApiConfig';

const clientServices = {
  createClient: async (data) => {
    return api.post('/client/create', data);
  },
  getClientsByCompany: async (companyId) => {
    return api.get(`/client/company/${companyId}`);
  },
  updateClient: async (id, data) => {
    return api.put(`/client/${id}`, data);
  },
  toggleClientStatus: async (id) => {
    return api.patch(`/client/${id}/toggle-status`);
  },
};

export default clientServices;
